import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { label: "Startseite", href: "#startseite" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Kontakt", href: "#kontakt" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/90 border-b border-slate-200/70 shadow-[0_4px_20px_rgb(10,25,47,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex h-20 items-center justify-between">
          <a
            href="#startseite"
            data-testid="logo-link"
            className="flex items-center"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_nz-clean-premium/artifacts/m4841m69_logo%20za%20flaer2.png"
              alt="NZ Clean Service Logo"
              className="h-8 md:h-10 w-auto transition-[filter] duration-300"
              style={{ filter: scrolled ? "none" : "brightness(0) invert(1)" }}
            />
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`nav-${n.href.replace("#", "")}`}
                className={`text-sm font-semibold transition-colors hover:text-[#0077E6] ${
                  scrolled ? "text-slate-700" : "text-white/90"
                }`}
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <Button
              asChild
              data-testid="header-cta-button"
              className="rounded-full bg-[#0077E6] px-6 text-white hover:bg-[#005bb5] transition-transform hover:scale-105 active:scale-95"
            >
              <a href="#kontakt">Kostenloses Angebot</a>
            </Button>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className={`md:hidden p-2 ${scrolled ? "text-[#0A192F]" : "text-white"}`}
            onClick={() => setOpen((v) => !v)}
            aria-label="Menü"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-slate-100 px-5 py-6 space-y-4"
        >
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="block text-base font-semibold text-slate-700 hover:text-[#0077E6]"
            >
              {n.label}
            </a>
          ))}
          <Button
            asChild
            className="w-full rounded-full bg-[#0077E6] text-white hover:bg-[#005bb5]"
          >
            <a href="#kontakt" onClick={() => setOpen(false)}>
              Kostenloses Angebot
            </a>
          </Button>
        </div>
      )}
    </header>
  );
};
